import { WhitelistAction } from '../global';
import { Contact, Dependent, PlanRequest, Questionnaire, TravellerType, TripInformation } from '../quote';
import { ME_EMPLOYEE_TYPES_API } from '../quote-form';
import { PAYMENT_TYPE } from '../traveller-payments';

export const PURCHASE_POLICY_START = 'PURCHASE_POLICY_START';
export const PURCHASE_POLICY_SUCCESS = 'PURCHASE_POLICY_SUCCESS';
export const PURCHASE_POLICY_FAILED = 'PURCHASE_POLICY_FAILED';
export const SWITCH_ORG_START = 'SWITCH_ORG_START';
export const SWITCH_ORG_FAILED = 'SWITCH_ORG_FAILED';
export const RESET_POLICY_CREATE = 'RESET_POLICY_CREATE';
export interface PaymentRequest {
  amount?: number;
  method?: string;
  type?: string;
  paymentDate?: string;
  tax?: number;
  premium?: number;
  cardReference?: string;
  maskedPan?: string;
  expiryDate?: string;
  cardHolderName?: string;
  details?: {
    cardOwnerReferenceNumber?: number;
    dataKey?: string;
    expiryDate?: string;
    maskedCard?: string;
    paymentType?: PAYMENT_TYPE;
    cardHolderName?: string;
  };
}
export interface PolicyPax {
  policyStatus?: string;
  policyNumber?: string;
  firstName?: string;
  lastName?: string;
  dateOfBirth?: string;
  referenceNumber?: string;
  age?: number;
  questionnaires?: Questionnaire[];
  contact?: Contact;
  plan?: PlanRequest;
  tripBookingDate?: string;
  payment?: PaymentRequest;
  payments?: PaymentRequest[];
  policyDelta?: DeltaPlan;
  bill96Consent?: boolean;
  lang?: string;
}
export interface DeltaPlan {
  policyNumber: string;
  deltaAmount: number;
}

export interface PolicyRequest extends WhitelistAction {
  organizationCode: string;
  originalQuoteNumber?: string;
  manulifeEmployeeName?: string;
  manulifeEmployeeRelationship?: ME_EMPLOYEE_TYPES_API;
  caller?: string;
  referenceId?: string;
  issuedBy?: string;
  referredBy?: string;
  endorsedBy?: string;
  updatedBy?: string;
  updatedAt?: string;
  createdAt?: string;
  transactionDate?: string;
  travellerType?: TravellerType;
  travellerCategory?: string;
  applicationDate?: string;
  groupNumber?: string;
  salesChannel?: string;
  tripInformation?: TripInformation;
  paxes?: PolicyPax[];
  dependents?: Dependent[];
}

export interface AdditionalData {
  familyCoverage: string;
  travellerCount: number;
  tripDestination: string;
}

export interface PolicyCreateStore {
  createPending?: boolean;
  response?: PolicyRequest;
  error?: unknown;
  loading?: boolean;
  additionalData?: AdditionalData;
  isQuoteSave?: boolean;
}

export interface PolicyCreateAction {
  type: string;
  payload?: PolicyRequest;
  additionalData?: AdditionalData;
  isQuoteSave?: boolean;
}
